import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Transition } from 'react-transition-group';
import { fg } from '@atlaskit/platform-feature-flags';
var duration = {
  enter: 0,
  exit: 100
};
/**
 * __Fade__
 *
 * A fade in animation used for spotlights.
 *
 * @internal
 */
export var Fade = function Fade(_ref) {
  var hasEntered = _ref.hasEntered,
    children = _ref.children,
    onExited = _ref.onExited;
  var nodeRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(Transition, _extends({
    in: hasEntered,
    timeout: duration,
    onExited: onExited,
    unmountOnExit: true,
    appear: true
  }, fg('platform_design_system_team_transition_group_r18') && {
    nodeRef: nodeRef
  }), function (status) {
    var base = {
      transition: "opacity ".concat(duration.exit, "ms"),
      opacity: 0
    };
    var anim = {
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 0
      }
    };
    var style = _objectSpread(_objectSpread({}, base), anim[status]);
    return children(style);
  });
};